import {
  StudioIdIcon,
  UsernameIcon,
  SubscriptionStatusIcon,
  EmailAddressIcon,
  CurrentStudioVersionIcon,
  LastUpdatedIcon,
  LastCommunicatedIcon,
  TotalCamerasIcon,
  RamIcon,
  GPUIcon,
  StorageIcon,
  ProcessorIcon,
  ForcePlateIcon,
  AllTimeIcon,
  TwentyFourHoursIcon,
  OneWeekIcon,
  OneMonthIcon,
  SixMonthIcon,
  OneYearIcon,
  DateCaptureIcon,
  CaptureQualityIcon,
  VideoCreattionTimeIcon,
  UploadTimeIcon,
  WaitingTimeIcon,
  ProcessingTimeIcon,
  VisualizationTimeIcon,
  TimeToUserIcon,
  TotalStrikersIcon,
  TotalwithActiveIcon,
  EstimatedSalesIcon,
  UploadSpeedIcon,
  DownloadSpeedIcon,
  CrossIcon,
  SmileIcon,
  CaptureHeaderIcon,
} from "icons";
import { getFormattedDate } from "utils/helpers";

export const infoData = {
  header: {
    heading: "Information",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      key: "studio_id",
      label: "Studio ID",
      value: "",
      LabelIcon: StudioIdIcon,
    },
    {
      id: 2,
      label: "Username",
      key: "username",
      value: "",
      LabelIcon: UsernameIcon,
    },
    {
      id: 3,
      label: "Subscription Status",
      key: "subscription_status",
      value: "",
      LabelIcon: SubscriptionStatusIcon,
      valueColor: "#F63E50",
    },
    {
      id: 4,
      label: "Email Address",
      key: "email",
      value: "alina.cris@gmail.com",
      LabelIcon: EmailAddressIcon,
    },
    {
      id: 5,
      label: "Current Studio Version",
      key: "current_version",
      value: "1.2.1",
      LabelIcon: CurrentStudioVersionIcon,
    },
    {
      id: 6,
      label: "Last Updated",
      key: "last_updated",
      value: "02.03.25",
      LabelIcon: LastUpdatedIcon,
    },
    {
      id: 7,
      label: "Last Communicated",
      key: "last_communicated",
      value: "03.03.25",
      LabelIcon: LastCommunicatedIcon,
    },
  ],
};

export function getUpdatedData({ apiObject, customData }) {
  if (!apiObject) return customData;

  const list = customData.list.map((item) => {
    let value = apiObject[item.key];
    value = item.key === "last_updated" ? getFormattedDate(value) : value;
    return {
      ...item,
      value,
    };
  });
  return { ...customData, list };
}

export const hardwareData = {
  header: {
    heading: "Hardware Specifications",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Total Cameras",
      key: "cameras",
      value: "2",
      LabelIcon: TotalCamerasIcon,
    },
    {
      id: 2,
      label: "RAM",
      key: "ram",
      value: "64GB",
      LabelIcon: RamIcon,
    },
    {
      id: 3,
      label: "GPU",
      key: "gpu",
      value: "RTX 4090",
      LabelIcon: GPUIcon,
    },
    {
      id: 4,
      label: "Storage",
      key: "storage",
      value: "1TB",
      LabelIcon: StorageIcon,
    },
    {
      id: 5,
      label: "Processor",
      key: "processor",
      value: "Core i7",
      LabelIcon: ProcessorIcon,
    },
    {
      id: 6,
      label: "Force Plate",
      key: "force_plates",
      value: "",
      valueIcon: CrossIcon,
      LabelIcon: ForcePlateIcon,
    },
  ],
};
export const networkData = {
  header: {
    heading: "Network Specification",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Upload Speed",
      value: "50MBPS",
      key: "upload_speed",
      LabelIcon: UploadSpeedIcon,
    },
    {
      id: 2,
      label: "Download Speed",
      key: "download_speed",
      value: "250MBPS",
      LabelIcon: DownloadSpeedIcon,
    },
  ],
};

export const captureData1 = {
  header: {
    heading: "Capture",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "All Time",
      value: "5000",
      LabelIcon: AllTimeIcon,
    },
    {
      id: 2,
      label: "24 Hrs",
      value: "05",
      LabelIcon: TwentyFourHoursIcon,
    },
    {
      id: 3,
      label: "1 Week",
      value: "05",
      LabelIcon: OneWeekIcon,
    },
    {
      id: 4,
      label: "1 Month",
      value: "190",
      LabelIcon: OneMonthIcon,
    },
    {
      id: 5,
      label: "6 Months",
      value: "800",
      LabelIcon: SixMonthIcon,
    },
    {
      id: 6,
      label: "1 Year",
      value: "4000",
      LabelIcon: OneYearIcon,
    },
  ],
};
export const captureData2 = {
  header: {
    heading: "Capture",
    icon: CaptureHeaderIcon,
  },
  list: [
    {
      id: 1,
      label: "Date",
      value: "04.03.25",
      LabelIcon: DateCaptureIcon,
    },
    {
      id: 2,
      label: "Capture Quality",
      value: "Excellent",
      LabelIcon: CaptureQualityIcon,
      isValueTag: true,
      tagIcon: SmileIcon,
    },
    {
      id: 3,
      label: "Video Creation Time",
      value: "12 sec",
      LabelIcon: VideoCreattionTimeIcon,
    },
    {
      id: 4,
      label: "Upload Time",
      value: "10 sec",
      LabelIcon: UploadTimeIcon,
    },
    {
      id: 5,
      label: "Waiting Time",
      value: "10 sec",
      LabelIcon: WaitingTimeIcon,
    },
    {
      id: 6,
      label: "Processing Time",
      value: "15 sec",
      LabelIcon: ProcessingTimeIcon,
    },
    {
      id: 7,
      label: "Visualization Time",
      value: "20 sec",
      LabelIcon: VisualizationTimeIcon,
    },
    {
      id: 8,
      label: "Time to User",
      value: "10 sec",
      LabelIcon: TimeToUserIcon,
    },
  ],
};
export const RevenueData = {
  header: {
    heading: "Revenue",
    icon: "Icon",
  },
  list: [
    {
      id: 1,
      label: "Total Strikers",
      value: "10,000",
      LabelIcon: TotalStrikersIcon,
    },
    {
      id: 2,
      label: "Total Strikers with Active Subscriptions",
      value: "5000",
      LabelIcon: TotalwithActiveIcon,
    },
    {
      id: 3,
      label: "Estimated Sales",
      value: "€100,000",
      LabelIcon: EstimatedSalesIcon,
      valueColor: "#73BB1C",
    },
  ],
};
